<div class="list-holder batch-holder">
  <div class="tools batch-tools">
    <div class="list-title">
      <h4>Batch Upload</h4>
      <small class="batch-hint">Add many vehicles at once from the Excel template. Only No-Duplicate rows are submitted.</small>
    </div>
    <div class="batch-actions" *ngIf="canManage">
      <button type="button" class="btn btn-sm btn-outline" (click)="downloadTemplate()" [disabled]="isDownloadingTemplate">
        <i class="fa" [ngClass]="isDownloadingTemplate ? 'fa-spinner fa-spin' : 'fa-download'"></i>
        Download Template
      </button>
      <input type="file" id="fleet-registry-batch-file" class="d-none" accept=".xlsx"
        (change)="onFileSelected($event)" [disabled]="isValidating || isSubmitting">
      <label for="fleet-registry-batch-file" class="btn btn-sm btn-default mb-0"
        [class.disabled]="isValidating || isSubmitting">
        <i class="fa" [ngClass]="isValidating ? 'fa-spinner fa-spin' : 'fa-upload'"></i>
        {{ isValidating ? 'Checking file...' : 'Upload Excel' }}
      </label>
    </div>
  </div>

  <div class="form-level-error" *ngIf="uploadError">
    <i class="fa fa-exclamation-circle"></i> {{ uploadError }}
  </div>

  <!-- Preview of the uploaded file: nothing is saved until Submit. -->
  <div class="batch-preview" *ngIf="preview">
    <div class="preview-head">
      <div>
        <strong>{{ preview.fileName }}</strong>
        <small class="d-block">
          {{ preview.totalRows }} row{{ preview.totalRows === 1 ? '' : 's' }} read ·
          {{ preview.activeVehicles }} of {{ preview.allowedActiveVehicles }} active vehicles used,
          {{ preview.remainingVehicles }} more allowed
        </small>
      </div>
      <div class="preview-filters">
        <button type="button" *ngFor="let filter of filters" class="filter-chip"
          [class.active]="previewFilter === filter.value" (click)="setPreviewFilter(filter.value)">
          {{ filter.label }} <span>{{ countFor(filter.value) }}</span>
        </button>
      </div>
    </div>

    <div class="form-level-error preview-alert" *ngIf="invalidMobileRows > 0">
      <i class="fa fa-exclamation-circle"></i>
      {{ invalidMobileRows }} row{{ invalidMobileRows === 1 ? ' has an' : 's have an' }} invalid Driver Mobile Number format.
      Use 09XXXXXXXXX (e.g. 09171234567). {{ invalidMobileRows === 1 ? 'It is' : 'They are' }} marked Invalid and will not be
      included in the submission.
      <a href="#" (click)="$event.preventDefault(); setPreviewFilter('INVALID')">Show Invalid rows</a>
    </div>

    <div class="list table-responsive">
      <div class="empty-state" *ngIf="filteredPreviewRows.length === 0">
        <h4>No rows with this status.</h4>
      </div>
      <table *ngIf="filteredPreviewRows.length > 0">
        <thead>
          <tr>
            <th>Row</th>
            <th>Plate Number</th>
            <th>Conduction Sticker</th>
            <th>Make/Model/Year</th>
            <th>Vehicle ID</th>
            <th>Driver</th>
            <th>Status</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedPreviewRows">
            <td>{{ row.rowNumber }}</td>
            <td>{{ row.values.plateNumber || '—' }}</td>
            <td>{{ row.values.conductionNumber || '—' }}</td>
            <td>{{ previewVehicle(row) }}</td>
            <td>{{ row.values.vehicleId || '—' }}</td>
            <td>{{ previewDriver(row) }}</td>
            <td>
              <span class="stat" [ngClass]="previewStatusClasses[row.status]">{{ previewStatusLabels[row.status] }}</span>
            </td>
            <td class="remarks">
              <ng-container *ngIf="row.issues.length; else noIssues">
                <div *ngFor="let issue of row.issues">{{ issue }}</div>
              </ng-container>
              <ng-template #noIssues>—</ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="list-footer preview-footer">
      <div class="pager" *ngIf="previewTotalPages > 1">
        <button (click)="goToPreviewPage(previewPage - 1)" [disabled]="previewPage === 1">
          <img src="../../../../assets/okito/images/icons/prev.svg" alt="Previous">
        </button>
        <ol>
          <li *ngFor="let page of previewPageNumbers" [class.active]="page === previewPage">
            <a href="#" (click)="$event.preventDefault(); goToPreviewPage(page)">{{ page }}</a>
          </li>
        </ol>
        <button (click)="goToPreviewPage(previewPage + 1)" [disabled]="previewPage === previewTotalPages">
          <img src="../../../../assets/okito/images/icons/next.svg" alt="Next">
        </button>
      </div>
      <div class="preview-submit">
        <small class="error-required" *ngIf="exceedsVehicleLimit">
          Only {{ preview.remainingVehicles }} more active vehicle{{ preview.remainingVehicles === 1 ? '' : 's' }} allowed.
          Raise the allowed number of vehicles or upload fewer rows.
        </small>
        <small *ngIf="!exceedsVehicleLimit && submittableRows.length === 0" class="text-muted">
          No No-Duplicate rows to submit.
        </small>
        <button type="button" class="btn btn-sm btn-outline" (click)="clearPreview()" [disabled]="isSubmitting">Cancel</button>
        <button type="button" class="btn btn-sm btn-default" (click)="openSubmitConfirm(submitConfirmModal)" [disabled]="!canSubmit">
          <i *ngIf="isSubmitting" class="fa fa-spinner fa-spin"></i>
          Submit {{ submittableRows.length }} vehicle{{ submittableRows.length === 1 ? '' : 's' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Batch uploads (parent) and their rows (children). -->
  <div class="batch-list">
    <div class="batch-list-title">
      <h5>Batch Uploads</h5>
      <button type="button" class="btn btn-sm btn-outline" (click)="loadBatches()" [disabled]="isBatchesLoading">
        <i class="fa fa-refresh" [class.fa-spin]="isBatchesLoading"></i> Refresh
      </button>
    </div>
    <div class="list table-responsive">
      <div class="empty-state" *ngIf="isBatchesLoading && batches.length === 0">
        <h4>Loading batch uploads...</h4>
      </div>
      <div class="empty-state" *ngIf="!isBatchesLoading && batchesError">
        <h4>Unable to load batch uploads.</h4>
        <small>{{ batchesError }}</small>
      </div>
      <div class="empty-state" *ngIf="!isBatchesLoading && !batchesError && batches.length === 0">
        <h4>No batch uploads yet.</h4>
      </div>

      <table *ngIf="!batchesError && batches.length > 0">
        <thead>
          <tr>
            <th>Uploaded</th>
            <th>File</th>
            <th>Uploaded By</th>
            <th>Vehicles</th>
            <th>Registered</th>
            <th>Failed</th>
            <th>Status</th>
            <th>Reason</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let batch of batches">
            <td>{{ batch.dateCreated }}</td>
            <td>{{ batch.fileName }}</td>
            <td>{{ batch.adminName || '—' }}</td>
            <td>{{ batch.totalRows }}</td>
            <td>{{ batch.successRows }}</td>
            <td>{{ batch.failedRows }}</td>
            <td><span class="stat" [ngClass]="batchStatusClass(batch.status)">{{ batchStatusLabel(batch.status) }}</span></td>
            <td class="remarks">{{ batch.failureReason || '—' }}</td>
            <td class="action-cell">
              <a href="#" (click)="$event.preventDefault(); openBatchDetails(batch, batchDetailsModal)">View Details</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="list-footer" *ngIf="batchTotalPages > 1">
      <div class="pager">
        <button (click)="goToBatchPage(batchPage - 1)" [disabled]="batchPage === 1 || isBatchesLoading">
          <img src="../../../../assets/okito/images/icons/prev.svg" alt="Previous">
        </button>
        <button (click)="goToBatchPage(batchPage + 1)" [disabled]="batchPage === batchTotalPages || isBatchesLoading">
          <img src="../../../../assets/okito/images/icons/next.svg" alt="Next">
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #submitConfirmModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Submit batch?</h5>
  </div>
  <div class="modal-body">
    <p class="mb-2">
      {{ submittableRows.length }} No-Duplicate vehicle{{ submittableRows.length === 1 ? '' : 's' }} from
      <strong>{{ preview?.fileName }}</strong> will be queued and added to this fleet's registry as active.
    </p>
    <small class="text-muted" *ngIf="(preview?.totalRows || 0) > submittableRows.length">
      {{ (preview?.totalRows || 0) - submittableRows.length }} Has-Duplicate or Invalid row(s) will be skipped.
    </small>
    <small class="d-block error-required mt-1" *ngIf="invalidMobileRows > 0">
      {{ invalidMobileRows }} of them {{ invalidMobileRows === 1 ? 'has' : 'have' }} an invalid Driver Mobile Number format (use 09XXXXXXXXX).
    </small>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="modal.close()" [disabled]="isSubmitting">Cancel</button>
    <button type="button" class="btn btn-default" (click)="submit()" [disabled]="isSubmitting">
      <i *ngIf="isSubmitting" class="fa fa-spinner fa-spin"></i>
      {{ isSubmitting ? 'Submitting...' : 'Submit' }}
    </button>
  </div>
</ng-template>

<ng-template #batchDetailsModal let-modal>
  <div class="modal-header">
    <div>
      <h5 class="modal-title">Batch Upload Details</h5>
      <small class="text-muted" *ngIf="selectedBatch">{{ selectedBatch.fileName }}</small>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body batch-details" *ngIf="selectedBatch as batch">
    <div class="detail-summary">
      <div><small>Status</small><span class="stat" [ngClass]="batchStatusClass(batch.status)">{{ batchStatusLabel(batch.status) }}</span></div>
      <div><small>Uploaded By</small><strong>{{ batch.adminName || '—' }}</strong></div>
      <div><small>Uploaded</small><strong>{{ batch.dateCreated }}</strong></div>
      <div><small>Completed</small><strong>{{ batch.dateCompleted || '—' }}</strong></div>
      <div><small>Vehicles</small><strong>{{ batch.totalRows }}</strong></div>
      <div><small>Registered</small><strong>{{ batch.successRows }}</strong></div>
      <div><small>Failed</small><strong>{{ batch.failedRows }}</strong></div>
    </div>
    <div class="form-level-error" *ngIf="batch.failureReason">
      <i class="fa fa-exclamation-circle"></i> {{ batch.failureReason }}
    </div>

    <div class="preview-filters detail-filters">
      <button type="button" *ngFor="let filter of rowStatusFilters" class="filter-chip"
        [class.active]="detailStatusFilter === filter.value" (click)="setDetailStatusFilter(filter.value)"
        [disabled]="isDetailLoading">
        {{ filter.label }}
      </button>
    </div>

    <div class="list-holder detail-list">
      <div class="list table-responsive">
        <div class="empty-state" *ngIf="isDetailLoading && detailRows.length === 0"><small>Loading rows...</small></div>
        <div class="form-level-error" *ngIf="detailError"><i class="fa fa-exclamation-circle"></i> {{ detailError }}</div>
        <div class="empty-state" *ngIf="!isDetailLoading && !detailError && detailRows.length === 0">
          <h4>No rows with this status.</h4>
        </div>
        <table *ngIf="detailRows.length > 0" [class.is-loading]="isDetailLoading">
          <thead>
            <tr>
              <th>Row</th>
              <th>Plate Number</th>
              <th>Conduction Sticker</th>
              <th>Make/Model/Year</th>
              <th>Vehicle ID</th>
              <th>Driver</th>
              <th>Status</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of detailRows">
              <td>{{ row.rowNumber }}</td>
              <td>{{ row.plateNumber || '—' }}</td>
              <td>{{ row.conductionNumber || '—' }}</td>
              <td>{{ rowVehicle(row) }}</td>
              <td>{{ row.vehicleId || '—' }}</td>
              <td>{{ rowDriver(row) }}</td>
              <td><span class="stat" [ngClass]="batchStatusClass(row.status)">{{ batchStatusLabel(row.status) }}</span></td>
              <td class="remarks">{{ row.failureReason || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="detail-footer">
      <small class="text-muted">{{ detailTotal }} row{{ detailTotal === 1 ? '' : 's' }}</small>
      <div class="pager detail-pager" *ngIf="detailTotalPages > 1">
        <button (click)="goToDetailPage(detailPage - 1)" [disabled]="detailPage === 1 || isDetailLoading">
          <img src="../../../../assets/okito/images/icons/prev.svg" alt="Previous">
        </button>
        <ol>
          <li *ngFor="let page of detailPageNumbers" [class.active]="page === detailPage">
            <a href="#" (click)="$event.preventDefault(); goToDetailPage(page)">{{ page }}</a>
          </li>
        </ol>
        <button (click)="goToDetailPage(detailPage + 1)" [disabled]="detailPage === detailTotalPages || isDetailLoading">
          <img src="../../../../assets/okito/images/icons/next.svg" alt="Next">
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="modal.close()">Close</button>
  </div>
</ng-template>
